<script setup lang="ts">
import { Primitive, type PrimitiveProps } from 'radix-vue'
import { type ButtonVariants, buttonVariants } from './data'
import { cn } from '@/lib/utils'

export interface IButton extends PrimitiveProps {
    variant?: ButtonVariants['variant']
    class?: string
    disabled?: boolean
    to?: string
}

export interface IButtonExtended extends IButton {
    id: string
    text: string
}

const props = withDefaults(defineProps<IButton>(), {
    as: 'button',
})
</script>

<template>
    <Primitive
        :as="as"
        :as-child="asChild || !!to"
        :disabled="disabled"
        :class="cn(buttonVariants({ variant }), props.class)"
    >
        <a
            v-if="to"
            :href="to"
        >
            <slot />
        </a>
        <template v-else>
            <slot />
        </template>
    </Primitive>
</template>
